import { GalleryAddress, GalleryItems } from 'src/app/Services/galleries.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Artist, ArtistsService } from '../../../Services/artists.service';
import { AuthConfig, AuthService, ResponseObject } from '../../../Services/auth.service';
import { NotificationsService } from '../../../Services/shared/notifications.service';
import { NotificationTypes } from '../../../app.enums';
import { GalleriesService, } from '../../../Services/galleries.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { SaveGalleryStaffRequest } from 'src/app/models/staff.model';
import { GalleryStaffService } from 'src/app/Services/gallery-staff.service';
import { ConnectionsService } from 'src/app/Services/connections.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { FileUpload } from 'primeng/fileupload';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { UsersService } from 'src/app/Services/users.service';
import { proBySourceEnum } from '../../../Services/auth.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-galleries',
    templateUrl: './galleries.component.html',
    styleUrls: ['./galleries.component.css'],
    providers: [GalleriesService, ConnectionsService],
    standalone: false
})
export class GalleriesComponent implements OnInit {
  public items: string[] = ['Artist', 'Manafacture', 'Public Gallery', 'Exhibition space', 'Charity', 'Government Organization', 'Other'];
  public addressTypes: string[] = ['StreetAddress', 'PostalAddress', 'DeliveredAddress'];
  public terms: string[] = ['3 Days', '7 Days', '30 Days'];
  @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  public enableCropper: boolean = true;
  public currentSelectedImageToCrop?: File;
  public showCropperDialog: boolean = false;
  public additionalFiles: any[] = [];
  public selectedFile!: File;
  // items:any;
  public commissionOptions: { value: number; label: string }[] = [];
  public selectedProduct: any;
  public galleries: GalleryItems[] = [];
  public formData: GalleryItems = {} as GalleryItems;
  public galleryItems = new GalleryItems();
  public venueLabel: string[] = [];
  public visible: boolean = false;
  public selectedGalleryAddress!: GalleryAddress;
  public uploader!: FormGroup;
  public isAddressTypeDisabled: boolean = false;
  public selectedTabIndex: number = 0;
  public isEditMode: boolean = false;
  public galleryDialogVisible: boolean = false;
  public authConfig: AuthConfig = {};
  public galleryStaffData:SaveGalleryStaffRequest[]=[]

  public galleriesLoading: boolean = true;
  public galleryId!:string;
  // Artist
  public connectedArtist: Artist[] = [];
  // staff
  public staffLoading: boolean = false;
  public Staff:SaveGalleryStaffRequest[]=[];
  public staffDailogVisible: boolean = false;
  public staffFormsData: SaveGalleryStaffRequest = {} as SaveGalleryStaffRequest;
  public id!:string;
  public renderGalleryStaff: boolean = false;
  public filterByArtflow: boolean = false;
  public filterByFreeTrial: boolean = false;
  public filterByStripe: boolean = false;
  public filterByAppleInAppPurchase: boolean = false;
  public subscriptionRules: SelectItem[]=[];
  public proBySource:any = proBySourceEnum;
  constructor(private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private galleriesService: GalleriesService,
    private artistService: ArtistsService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private uploadService: CloudinaryImageService,
    private fb: FormBuilder,
    private galleryStaffService:GalleryStaffService,
    private connectionsService: ConnectionsService,
    private userService: UsersService,
    private subscriptionRulesService: SubscriptionRulesService,
    private transloco: TranslocoService
  ) {
    this.uploader = this.fb.group({
      file: [null],

    });
    this.formData = {} as GalleryItems;
    this.staffFormsData = new SaveGalleryStaffRequest();
    this.selectedGalleryAddress = new GalleryAddress();
    this.galleryItems.GallerySaleType = 'Consignment';
    // Generate options from 5% to 90% with a step of 5%
    for (let i = 5; i <= 90; i += 5) {
      this.commissionOptions.push({ value: i, label: `${i}%` });
    }
  }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    if (this.authService.isAuthenticated()) {
      this.fetch();
    }
    this.selectedTabIndex = 0
    this.getSubscriptionRuleSetsDropdown()
  }

  public getSubscriptionRuleSetsDropdown() {
    this.ngxSpinnerService.show();
    this.subscriptionRulesService.fetchRuleSetsDropdown().subscribe((ActiveSubscriptionRule: SelectItem[]) => {
      this.subscriptionRules = ActiveSubscriptionRule
      console.log(this.subscriptionRules)
      // if (this.subscriptionRules.length > 0) {
      //   // const lastSubscriptionRule = this.subscriptionRules[this.subscriptionRules.length - 1];
      //   const firstSubscriptionRule = this.subscriptionRules[0];
      //   console.log(firstSubscriptionRule)
      //   this.galleryItems.SubscriptionRuleSetId = firstSubscriptionRule.value; // Assuming `value` is the ID or key of the rule set
      //   console.log(this.galleryItems.SubscriptionRuleSetId)
      // }
      this.ngxSpinnerService.hide()
    }, (error) => { console.error('Error while fetching subscription rules data', error); this.ngxSpinnerService.hide(); })
  }
  
  public navigateToViewArtist(rowData: Artist) {
    this.router.navigate(['/profile', rowData.Id]);
  }

  public getConnectedArtists() {
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedArtists(this.galleryId, false).subscribe((data: Artist[]) => {
      this.connectedArtist = data;
      console.log('connectedArtist', this.connectedArtist)
      this.ngxSpinnerService.hide();
    }, (error) => { console.error('Error fetching connected Artist:', error); this.ngxSpinnerService.hide(); });
  }

  private fetch() {
    this.ngxSpinnerService.show();
    this.galleriesLoading = true;
    this.galleriesService.fetch().subscribe((galleries) => {
      this.galleries = galleries;
      console.log('this.galleries', this.galleries);

      // this.venueLabel = this.galleries.map((gallery) => gallery.Name);

      this.galleriesLoading = false;
      this.ngxSpinnerService.hide();
    }, (error) => {
      console.error(error);
      this.galleriesLoading = false;
      this.ngxSpinnerService.hide();
    });
  }

  public saveGallery() {
    this.ngxSpinnerService.show();
    this.galleriesService.saveGallery(this.galleryItems).subscribe((response: ResponseObject) => {
      this.ngxSpinnerService.hide();
      if (response.Success) {
        console.log('API Response:', response);
        this.notificationsService.showNotification(this.transloco.translate('galleries.successTitle'), response.ResponseMessage, NotificationTypes.Success);
        this.fetch();
        this.galleryDialogVisible = false;
        this.selectedTabIndex = 0;
      }
      else {
        this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      }
    },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
    this.galleryDialogVisible = false
  }

  public onGalleryItemsChange(updatedGalleryItems: any) {
    // Update the parent's galleryItems with the emitted data
    this.galleryItems.GalleryAddresses = updatedGalleryItems;
  }

  public editGallery(galleryId: string) {   
    this.galleryId = galleryId;   
    const currentGallery = this.galleries.find((gallery) => gallery.Id === galleryId);
    if (currentGallery) {
      this.renderGalleryStaff = true;
      this.isEditMode = true;
      // Create a new instance of GalleryItems to ensure change detection
      this.galleryItems = { ...currentGallery, GalleryAddresses: [...currentGallery.GalleryAddresses] };
      // this.getAllGalleryStaff();
      this.getConnectedArtists();
      if (this.galleryItems.GalleryAddresses.length === 0) {
        this.addressTypes = ['StreetAddress', 'PostalAddress', 'DeliveredAddress'];
      }
      // Remove already displayed address types from the dropdown
      this.updateAddressTypes();
      this.selectedTabIndex = 0;
      this.galleryDialogVisible = true;
      console.log('Editing Gallery:', this.galleryItems);      

    } else {
      console.error('Gallery not found for Id:', galleryId);
    }
  }

  public deleteGallery(id: string) {
    this.confirmationService.confirm({
      accept: () => {
        this.ngxSpinnerService.show();
        this.galleriesService.deleteGallery(id).subscribe((response: ResponseObject) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.notificationsService.showNotification(this.transloco.translate('galleries.successTitle'), response.ResponseMessage, NotificationTypes.Success);
            var index = this.galleries.findIndex((gallery) => gallery.Id == id);
            if (index >= 0) {
              this.galleries = this.galleries.filter((gallery) => gallery.Id !== id);
            }
          } else { this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
        }, (error: any) => { console.error(error); this.ngxSpinnerService.hide(); });
      }
    });
  }

  private updateAddressTypes() {
    // Filter out address types that are already present in galleryItems.GalleryAddresses
    this.addressTypes = this.addressTypes.filter(type =>
      this.galleryItems.GalleryAddresses.every(address => address.AddressType !== type)
    );
  }

  public showGalleryDialog() {
    // this.galleryItems = new GalleryItems();
    this.galleryDialogVisible = true;
    this.isEditMode = false;
    this.selectedTabIndex = 0;

  }

  public closeGalleryDialog(): void {
    this.galleryDialogVisible = false;
    // Reset the form when the dialog is closed
    this.formData = {} as GalleryItems;
    this.selectedTabIndex = 0;    
  }

  public closeDialog(): void {
    this.visible = false;
    this.renderGalleryStaff = false;
    this.selectedGalleryAddress = new GalleryAddress();
    this.galleryItems = new GalleryItems();
    this.isAddressTypeDisabled = false;
    this.addressTypes = ['StreetAddress', 'PostalAddress', 'DeliveredAddress'];
    this.updateAddressTypes();
  }




  // Method for handling file selection
  // public onFileSelected(event: any) {
  //   this.selectedFile = event.target.files[0]; // Get the selected file
  //   console.log(this.selectedFile);

  //   // Check if the selected file is an image
  //   const isImage = this.selectedFile && this.selectedFile.type.includes('image');
  //   if (isImage) {
  //     this.showCropperDialog = true; // Show the cropper dialog
  //     this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
  //   } else {
  //     console.log('Selected file is not an image');
  //   }
  // }

  public onFileSelected(files: File[]) {
    if(files.length > 0){
      this.selectedFile = files[0]; // Get the selected file
      console.log(this.selectedFile);

      // Check if the selected file is an image
      const isImage = this.selectedFile && this.selectedFile.type.includes('image');
      if (isImage) {
        this.showCropperDialog = true; // Show the cropper dialog
        this.currentSelectedImageToCrop = this.selectedFile; // Set the image to crop
      } else {
        console.log('Selected file is not an image');
      }
    }
  }

  // Method to handle the cropped image
  public onImageCropped(croppedImage: ImageCroppedResponse) {
    console.log(croppedImage);
    // Set the cropped image as the selected file
    this.selectedFile = croppedImage.CroppedImage;
    // Now upload the cropped image
    this.uploadImage();
    // Close the cropper dialog
    this.showCropperDialog = false;
  }

  // Method to handle closing the cropper dialog
  public onImageCropperClose($event: any) {
    if ($event.skipCropping == true) {
      this.selectedFile = null!;
      this.showCropperDialog = false;
      if(this.fileUpload){
        this.fileUpload.clear();
      }
    }
  }

  // Method to upload the image
  public uploadImage() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('ImageFile', this.selectedFile);
      this.uploadService.uploadImage(formData).subscribe(
        (res: any) => {
          this.galleryItems.GalleryImgUrl = res;
        },
        (error) => {
          console.error('Error uploading image:', error);
        }
      );
    } else {
      console.log('No image to upload.');
    }
  }

  // Method to remove the uploaded image
  public removeImg() {
    this.galleryItems.GalleryImgUrl = null!;
  }
  

  public switchAccount(rowData:Artist): void {
    this.ngxSpinnerService.show();
    this.authService.switchAccount(rowData.Id || '').subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.router.navigate(['/ds-gallery-dashboard']).then(() => {
            location.reload();
          });
          return;
        }
        this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public deleteAddress(id: any) {
    this.confirmationService.confirm({
      accept: () => {
        this.ngxSpinnerService.show();
        this.galleriesService.deleteAddress(id).subscribe((response: ResponseObject) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            var index = this.galleryItems.GalleryAddresses.findIndex((address) => address.Id == id);
            if (index >= 0) {
              const deletedAddress = this.galleryItems.GalleryAddresses.splice(index, 1)[0];

              // Add the deleted address type back to the dropdown
              if (deletedAddress && deletedAddress.AddressType) {
                this.addressTypes.push(deletedAddress.AddressType);
                this.addressTypes = [...this.addressTypes]; // Ensure Angular detects the change
              }
            }
            this.notificationsService.showNotification(this.transloco.translate('galleries.successTitle'), response.ResponseMessage, NotificationTypes.Success);
          } else { this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
        }, (error: any) => { console.error(error); this.ngxSpinnerService.hide(); });
      }
    });
  }

  public submitGalleryForm() {
    console.log('Form data before submission:', this.formData);
    if (this.formData) {
      console.log('Form submitted!', this.formData);
      this.saveGallery();
    } else {
      console.error('Form data is null or undefined.');
    }
  }
  
  public showDailog(){
    this.staffDailogVisible =true
    this.isEditMode = false;
  }

  public onCancel(){
    this.staffDailogVisible = false
    this.staffFormsData = {};
  }

  public switchToProAccount(Id: string,setPro: boolean){
    console.log('Switch to pro ', Id,setPro);
    this.ngxSpinnerService.show();
    this.userService.proAnyUserByPlateformUser(Id,setPro).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('galleries.successTitle'), response.ResponseMessage, NotificationTypes.Success);
          this.fetch();
        }
        else{
          this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.notificationsService.showNotification(this.transloco.translate('galleries.errorTitle'), error, NotificationTypes.Error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public getFilteredGalleries() {
    // this.ngxSpinnerService.show();
    // this.galleriesService.fetch().subscribe((galleries) => {
    //   this.galleries = galleries;
      
    //   this.ngxSpinnerService.hide();
    // }, (error) => {
    //   console.error(error); this.ngxSpinnerService.hide();
    //   // this.galleryProductsLoaded = true;
    // });
    if (this.filterByArtflow) {
      this.galleries = this.galleries.filter(gallery => gallery.ProBySource == this.proBySource.Artflow);
    }
    else if (this.filterByFreeTrial) {
      this.galleries = this.galleries.filter(gallery => gallery.ProBySource == this.proBySource.FreeTrial);

    }
    else if (this.filterByStripe) {
      this.galleries = this.galleries.filter(gallery => gallery.ProBySource == this.proBySource.Stripe);
    }
    else if (this.filterByAppleInAppPurchase) {
      this.galleries = this.galleries.filter(gallery => gallery.ProBySource == this.proBySource.AppleInAppPurchase);
    }else{
      this.fetch();
    }
    console.log('Filtered galleryProducts', this.galleries);
  }
 
}
